import { useStore } from '~/store';
import { EditorStage } from './EditorStage';
import { GridOverlay } from './GridOverlay';
import { GuidelinesOverlay } from './GuidelinesOverlay';
import { PinOverlay } from './PinOverlay';
import { ReferencePointOverlay } from './ReferencePointOverlay';
import { SelectionPopover } from './SelectionPopover';
import { SnapToggleChip } from './SnapToggleChip';

export function SpriteStage() {
  const framingMode = useStore((s) => s.pin.framingMode);
  const stageScale = useStore((s) => s.editor.stageScale);
  return (
    <div className="relative h-full w-full">
      <EditorStage
        overlays={
          <>
            {framingMode === 'pin' ? <PinOverlay /> : <GridOverlay />}
            <GuidelinesOverlay />
            <ReferencePointOverlay stageScale={stageScale} />
          </>
        }
      />
      <SelectionPopover />
      <SnapToggleChip />
    </div>
  );
}
